module.exports = __webpack_public_path__ + "static/media/ejzcard.3c2c8d4c.png";